<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <vue-cookie-comply :preferences="preferences" acceptAllLabel="Autoriser" preferencesLabel="Paramétrer"
        @on-accept-all-cookies="onAcceptAll" @on-save-cookie-preferences="onSavePreferences">

        <template v-slot:header>
            <header>
                <h3>Cookies</h3>
                <p>Nous utilisons de cookies pour le bon fonctionnement su site et pour récolter des statistiques
                    d'utilisation.<br>Vous pouvez paramétrer les cookies que vous souhaitez activer en cliquant sur le
                    bouton Paramétrer.</p>
            </header>
        </template>

        <template v-slot:modal-header>
            <h3>Paramètres de cookies</h3>
        </template>
    </vue-cookie-comply>
</template>

<script setup lang="ts">
import { consentGoogleAnalytics } from "@/helpers/analytics.helper";
import { onMounted } from "vue";

const preferences = [
    {
        title: "Fonctionnalités essentielles",
        description: "Sans ces fonctionnalités essentielles, nous pourrions ne pas être en mesure de vous permettre d’accéder à notre site web ou application et de vous fournir nos services de façon optimale. Il s’agit par exemple de la conservation vos choix concernant le dépôt de cookies. Cette finalité est requise par notre site pour fonctionner normalement et ne peut pas être désactivée.",
        items: [{
            label: "Active",
            value: "essential",
            isRequired: true
        }],
    },
    {
        title: "Statistiques",
        description: "Ces cookies nous permettent de mesurer le trafic et l’activité des visiteurs sur notre site, afin d’en améliorer le fonctionnement et de comprendre comment les visiteurs interagissent avec notre site. Les informations collectées sont anonymes et agrégées.",
        items: [{
            label: "Google Analytics",
            value: "ga",
            isEnable: true,
        }],
    }
];

onMounted(() => {
    if(localStorage.getItem("cookie-comply") == null) {
        return;
    }
    if(localStorage.getItem("cookie-comply") == 'all' || localStorage.getItem("cookie-comply")?.match(/ga/)) {
        consentGoogleAnalytics();
    }
});

const onAcceptAll = () => {
    consentGoogleAnalytics();
};

const onSavePreferences = (preferences: string[]) => {
    if(preferences.includes("ga")) {
        consentGoogleAnalytics();
    }
};
</script>

<style lang="sass">
</style>
